import { useState } from "react";
import { NavLink, Navigate, Route, Routes, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LayoutGrid, Package, ShoppingCart, Settings as SettingsIcon, Tag, LogOut, ArrowLeft } from "lucide-react";
import AdminDashboard from "./AdminDashboard";
import AdminProducts from "./AdminProducts";
import AdminOrders from "./AdminOrders";
import AdminSettings from "./AdminSettings";
import AdminCategories from "./AdminCategories";

export default function AdminLayout() {
    const { user, loading, logout } = useAuth();
    const [open, setOpen] = useState(false);
    if (loading) return <div className="p-10">Cargando…</div>;
    if (!user) return <Navigate to="/login" replace />;
    if (user.role !== "admin") return <Navigate to="/" replace />;

    const link = "flex items-center gap-3 px-4 py-2.5 text-sm rounded-md text-bone/70 hover:bg-ink2 hover:text-bone transition";
    const active = "bg-ink2 text-bone";

    return (
        <div className="min-h-screen flex bg-[#FAF9F6]">
            <aside className={`fixed lg:static inset-y-0 left-0 z-40 bg-ink w-64 flex-shrink-0 flex flex-col transform ${open ? "translate-x-0" : "-translate-x-full"} lg:translate-x-0 transition-transform`}>
                <div className="p-6 border-b border-ink2">
                    <p className="font-display text-bone text-xl">J&M Admin</p>
                    <p className="text-xs text-bone/50 mt-1">{user.email}</p>
                </div>
                <nav className="flex-1 p-4 space-y-1">
                    <NavLink to="/admin" end onClick={() => setOpen(false)} className={({ isActive }) => `${link} ${isActive ? active : ""}`}><LayoutGrid className="w-4 h-4" /> Dashboard</NavLink>
                    <NavLink to="/admin/productos" onClick={() => setOpen(false)} className={({ isActive }) => `${link} ${isActive ? active : ""}`} data-testid="admin-tab-products"><Package className="w-4 h-4" /> Productos</NavLink>
                    <NavLink to="/admin/categorias" onClick={() => setOpen(false)} className={({ isActive }) => `${link} ${isActive ? active : ""}`} data-testid="admin-tab-categories"><Tag className="w-4 h-4" /> Categorías</NavLink>
                    <NavLink to="/admin/pedidos" onClick={() => setOpen(false)} className={({ isActive }) => `${link} ${isActive ? active : ""}`} data-testid="admin-tab-orders"><ShoppingCart className="w-4 h-4" /> Pedidos</NavLink>
                    <NavLink to="/admin/configuracion" onClick={() => setOpen(false)} className={({ isActive }) => `${link} ${isActive ? active : ""}`} data-testid="admin-tab-settings"><SettingsIcon className="w-4 h-4" /> Configuración</NavLink>
                </nav>
                <div className="p-4 border-t border-ink2 space-y-2">
                    <Link to="/" className="flex items-center gap-2 text-xs text-bone/60 hover:text-bone"><ArrowLeft className="w-3 h-3" /> Volver a la tienda</Link>
                    <button onClick={logout} className="flex items-center gap-2 text-xs text-bone/60 hover:text-terracotta"><LogOut className="w-3 h-3" /> Cerrar sesión</button>
                </div>
            </aside>
            <div className="flex-1 min-w-0">
                <header className="lg:hidden bg-ink text-bone p-4 flex justify-between items-center">
                    <p className="font-display">J&M Admin</p>
                    <button onClick={() => setOpen(!open)} className="text-bone">{open ? "×" : "☰"}</button>
                </header>
                <main className="p-6 lg:p-10">
                    <Routes>
                        <Route index element={<AdminDashboard />} />
                        <Route path="productos" element={<AdminProducts />} />
                        <Route path="categorias" element={<AdminCategories />} />
                        <Route path="pedidos" element={<AdminOrders />} />
                        <Route path="configuracion" element={<AdminSettings />} />
                    </Routes>
                </main>
            </div>
        </div>
    );
}
